import { type OcPlusRepub, REPUB_COUNTRY, type RepubCountry, SUPPORTED_REPUB_NAMES } from '@cx-web/domain-types';

import { type Repub, REPUBS } from '@cx-modules/constants';

import { getRepubHomeUrl, getRepubPath } from './repubs';

export type RepubIs = Record<Repub, boolean>;

export type RepubMeta = {
  repubCountry: RepubCountry;
  repubHomeUrl: string;
  repubIs: RepubIs;
  repubIsOCPlus: boolean;
  repubLowerCase: string;
  repubPath: string;
};

export function getRepubMetaFromRepub(repub: Repub): RepubMeta {
  const repubIs = Object.entries(REPUBS).reduce((a, [key, config]) => {
    return {
      ...a,
      [key]: repub === config.name,
    };
  }, {} as RepubIs);

  const repubLowerCase = repub.toLowerCase();
  const repubIsOCPlus = SUPPORTED_REPUB_NAMES.some(name => repubIs[name]);

  const repubCountry = repubIsOCPlus ? REPUB_COUNTRY[repub as OcPlusRepub] : 'uk';

  return {
    repubIs,
    repubIsOCPlus,
    repubPath: getRepubPath(repub),
    repubHomeUrl: getRepubHomeUrl(repub),
    repubLowerCase: repubLowerCase,
    repubCountry,
  };
}

export function isOcPlusRepub(repub: Repub): repub is OcPlusRepub {
  const { repubIsOCPlus } = getRepubMetaFromRepub(repub);
  return repubIsOCPlus;
}
